import React from 'react';

const SelectOptions = ({ name, id, labelTitle, value, onChangeHandler, options, errors, ...props }) => {
	return (
		<div className="form-group">
			<label htmlFor={id}>{labelTitle}</label>
			<select name={name} id={id} value={value} onChange={onChangeHandler} {...props}>
				{options &&
					options.map((option, index) => (
						<option key={index} value={option.value}>
							{option.label}
						</option>
					))}
			</select>
			{errors && <p className="error">{errors}</p>}
		</div>
	);
};
export default SelectOptions;
